import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";
import type { SpecificationMetadataState } from "types";
import type { Ref } from "vue";

const { data } = useIDBKeyval<SpecificationMetadataState[]>(
  "disinfectionSpecifications",
  [],
  {
    shallow: false,
  }
);
export function useDisinfectionSpecificationsState(): Ref<
  SpecificationMetadataState[]
> {
  return data;
}
